import { ref } from 'vue'

export const useShortenUrl = async (url: string) => {
  const fullUrl = ref(url)
  const shortUrl = ref(null)

  const response = await fetch(`https://api.shrtco.de/v2/shorten?url=${fullUrl.value}`)
  const data = await response.json()
  shortUrl.value = data.result.full_short_link

  console.log(fullUrl.value, shortUrl.value)

  return shortUrl
}
